import PropTypes from 'prop-types'

import TableMobile from '../../../ui/components/TableMobile'
import { useShippingStates } from '../../../services/shippingsTracking'

const Results = ({ data }) => {
  const shippingCodes = data?.map(item => item.info.shippingCode) || []

  const { data: shippingsStates } = useShippingStates(shippingCodes)

  return <TableMobile states={shippingsStates} data={data} isResultTable />
}

Results.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      info: PropTypes.shape({
        shippingCode: PropTypes.bool,
        recipientAddress2: PropTypes.string,
        date: PropTypes.string,
        shippingStatusCode: PropTypes.shape({
          canCancel: PropTypes.bool,
          label: PropTypes.string,
          reason: PropTypes.string,
          severity: PropTypes.string.isRequired,
          statusCode: PropTypes.string,
        }),
      }),
    }),
  ),
}

export default Results
